export const defaultCenter = {
  lat: 25.0657,
  lng: 55.1713,
};
// current coordinates of user
export const getBrowserLocation = () => new Promise((resolve, reject) => {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude: lat, longitude: lng } = pos.coords;
        resolve({ lat, lng });
      },
      () => {
        reject(defaultCenter);
      },
    );
  } else {
    reject(defaultCenter);
  }
});
